import React from 'react';
import { QuestionRendererProps } from './types';
import { getQuestionTypeConfig } from '../../../config/questionTypeRegistry';
export function QuestionRendererFactory(props: QuestionRendererProps) {
  const {
    question
  } = props;
  const config = getQuestionTypeConfig(question.questionType || 'multiple_choice');
  const Renderer = config.Renderer;
  return <Renderer {...props} data-id="element-1491" />;
}